import { defaultProfileImage } from "./constants"
import * as Yup from "yup";

export const urlToFile = async (
    url: string,
    filename: string,
    mimeType?: string
): Promise<File> => {
    const response = await fetch(url)
    const blob = await response.blob()
    return new File([blob], filename, {
        type: mimeType || blob.type,
    })
}

export const getFileNameFromUrl = (url: string): string => {
    try {
        const parsedUrl = new URL(url)
        return parsedUrl.pathname.split('/').pop() || ''
    } catch {
        return ''
    }
}

export const handleImageErrorBlack = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // e.currentTarget.src = defaultExperienceImage
    e.currentTarget.style.display = "none";
    e.currentTarget.parentElement.style.backgroundColor = "black";
}

export const handleImageErrorGray = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // e.currentTarget.src = defaultExperienceImage
    e.currentTarget.style.display = "none";
    e.currentTarget.parentElement.style.backgroundColor = "#F3F3F3";
}

export const handleImageErrorProfile = (e: React.SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.src = defaultProfileImage
}

export const imageOrUrlSchema = ({
  required = true,
  maxSizeMB = 5,
  allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"],
  requiredMessage = "Cover image is required",
} = {}) => {
  let schema = Yup.mixed().nullable();

  if (required) {
    schema = schema.required(requiredMessage);
  } else {
    schema = schema.notRequired();
  }

  return schema
    .test("fileOrUrl", "Only images or valid URLs allowed", (value) => {
      if (!value) return !required;

      // File
      if (value instanceof File) {
        return allowedTypes.includes(value.type);
      }

      // URL string
      if (typeof value === "string") {
        if (!value.trim()) return !required;
        try {
          new URL(value);
          return true;
        } catch {
          if (value.startsWith('/') || value.startsWith('http') || value.startsWith('blob:')) {
            return true;
          }
          return false;
        }
      }

      return false;
    })
    .test("fileSize", `Max size is ${maxSizeMB}MB`, (value) => {
      if (value instanceof File) {
        return value.size <= maxSizeMB * 1024 * 1024;
      }
      return true;
    });
};